import service from '../../utils/request'


const getLiveInfo = (params) => {
    return service({
        url: `api/live/getLiveBroadcast?liveId=${params.liveId}&belong=${params.belong}`,
        method: 'get'
    })
}
const liveLogin = (data) => {
    return service({
        url: 'api/live/toLiveBroadcast',
        method: 'POST',
        data
    })
}
const liveFiestPage = (params) => {
    return service({
        url: `api/live/toLiveFiestPage?liveId=${params.liveId}`,
        method: 'GET'
    })
}

const getLiveBroadcastList = (params) => {
    return service({
        url: `api/live/getLiveBroadcastList?liveId=${params.liveId}`,
        method: 'GET'
    })
}

export {
    getLiveInfo,
    liveLogin,
    liveFiestPage,
    getLiveBroadcastList
}